module.exports = __webpack_public_path__ + "files/50cf5deb508b57c35d9b76a235f75312.png";